import type { IconProps } from './IconProps';

export const CheckVerifiedIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={props.width ?? 32}
    height={props.height ?? 32}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1785 2.87232C17.7705 0.820228 14.2288 0.820228 11.8208 2.87232C11.216 3.38772 10.4641 3.69919 9.67197 3.7624C6.51819 4.01408 4.01383 6.51844 3.76216 9.67221C3.69895 10.4643 3.38748 11.2163 2.87208 11.8211C0.819984 14.2291 0.819984 17.7708 2.87208 20.1788C3.38748 20.7836 3.69895 21.5355 3.76216 22.3276C4.01383 25.4814 6.51819 27.9858 9.67197 28.2374C10.4641 28.3006 11.216 28.6121 11.8208 29.1275C14.2288 31.1796 17.7705 31.1796 20.1785 29.1275C20.7833 28.6121 21.5353 28.3006 22.3274 28.2374C25.4812 27.9858 27.9855 25.4814 28.2372 22.3276C28.3004 21.5355 28.6119 20.7836 29.1273 20.1788C31.1794 17.7708 31.1794 14.2291 29.1273 11.8211C28.6119 11.2163 28.3004 10.4643 28.2372 9.67221C27.9855 6.51843 25.4812 4.01408 22.3274 3.7624C21.5353 3.6992 20.7833 3.38772 20.1785 2.87232ZM21.6091 13.6094C22.1298 13.0887 22.1298 12.2445 21.6091 11.7238C21.0884 11.2031 20.2442 11.2031 19.7235 11.7238L14.6663 16.781L12.9425 15.0571C12.4218 14.5364 11.5776 14.5364 11.0569 15.0571C10.5362 15.5778 10.5362 16.422 11.0569 16.9427L13.7235 19.6094C14.2442 20.1301 15.0885 20.1301 15.6091 19.6094L21.6091 13.6094Z"
      fill="url(#paint0_linear_4295_27701)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4295_27701"
        x1="9.13993"
        y1="0.986009"
        x2="15.9997"
        y2="30.6666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7374A0" stopOpacity="0.71" />
        <stop offset="1" stopColor="#7374A0" stopOpacity="0.49" />
      </linearGradient>
    </defs>
  </svg>
);
